/**
 * Faixa de 3 diferenciais entre o hero e as bikes.
 * Porte de `bicicletas_peniel_prototipo.html` linhas 115-141.
 *
 * O `pt-8 md:pt-4` nos itens 2 e 3 compensa o divisor horizontal do mobile —
 * detalhe do protótipo que é fácil perder no porte.
 */
import { Icone, type NomeIcone } from '@/shared/ui/Icone.jsx'

const DIFERENCIAIS: Array<{ icone: NomeIcone; titulo: string; texto: string }> = [
  {
    icone: 'chave',
    titulo: 'Revisão Completa',
    texto: 'Todas as nossas bikes usadas passam por uma revisão rigorosa antes da venda.',
  },
  {
    icone: 'etiqueta',
    titulo: 'Preço Justo',
    texto: 'Trabalhamos com os melhores preços do mercado, para novos e seminovos.',
  },
  {
    icone: 'headset',
    titulo: 'Atendimento Premium',
    texto: 'Tire suas dúvidas e feche negócio diretamente pelo WhatsApp, sem burocracia.',
  },
]

export function TiraDeDiferenciais() {
  return (
    <section className="border-b border-gray-100 bg-white py-12" aria-labelledby="titulo-diferenciais">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Visualmente oculto, mas presente na árvore. Sem ele a página saltava
            do <h1> direto para os <h3> dos cards, pulando um nível — e a escada
            de títulos é como o leitor de tela navega a página. */}
        <h2 id="titulo-diferenciais" className="sr-only">
          Nossos diferenciais
        </h2>
        <ul className="grid grid-cols-1 divide-y divide-gray-100 text-center md:grid-cols-3 md:divide-x md:divide-y-0">
          {DIFERENCIAIS.map((item, indice) => (
            <li key={item.titulo} className={`p-4 ${indice > 0 ? 'pt-8 md:pt-4' : ''}`}>
              <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-full bg-brand-50 text-2xl text-brand-600">
                <Icone nome={item.icone} />
              </div>
              <h3 className="mb-2 text-lg font-bold text-gray-900">{item.titulo}</h3>
              <p className="text-gray-500">{item.texto}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
